import { useStripeContext } from "../context/StripeContext";

/**
 * Hook wrapper around StripeContext for backward compatibility.
 * This allows existing components to continue using the same API.
 */
export const useStripeOnboarding = () => {
  const context = useStripeContext();

  // Return the same interface as before
  return {
    errorMessage: context.errorMessage,
    statusMessage: context.statusMessage,
    isLoading: context.isLoading,
    stripeConnectInstance: context.stripeConnectInstance,
    detailsSubmitted: context.detailsSubmitted,
    isAccountEnabled: context.isAccountEnabled,
    isReady: context.isAccountEnabled, // Alias for backward compatibility and clarity
    accountId: context.accountId,
    createdTimestamp: context.createdTimestamp,
    eventuallyDueRequirements: context.eventuallyDueRequirements,
    handleCreateAccount: context.handleCreateAccount,
    handleInitializeStripe: context.handleInitializeStripe,
    handleLogout: context.handleLogout,
    updateAccount: context.updateAccount,
  };
};
